import ModalStore from './ModalStore'
import { insuranceProductServer } from '../common/api'

class PaProduct extends ModalStore {
  constructor() {
    super('taProductStore', {
      all: [],
      current: {},
      configs: [],
    })
  }

  fetch = async param => {
    const res = await insuranceProductServer.get('/ta_products')
    this.$setState('all', res.data.data.products)
  }

  create = async param => {
    await insuranceProductServer.post('/ta_products', {
      ...param,
    })
  }

  fetchConfig = async () => {
    const resConfigs = await insuranceProductServer.get(`/ta_products/configs`)
    this.$setState('configs', resConfigs.data.data.configs.attributes)
  }

  fetchById = async param => {
    const res = await insuranceProductServer.get(`/ta_products/${param}`)
    const resConfigs = await insuranceProductServer.get(`/ta_products/configs`)

    this.$setState('configs', resConfigs.data.data.configs.attributes)
    this.$setState('current', res.data.data.product)
  }

  update = async (id, param) => {
    const res = await insuranceProductServer.put(`/ta_products/${id}`, {
      ...param,
    })
    this.$setState('current', res.data.data.product)
  }

  delete = async id => {
    await insuranceProductServer.delete(`/ta_products/${id}`)
  }

  updateStatusPublishDetail = async (id, param) => {
    const res = await insuranceProductServer.post(`/ta_products/${id}/publish`)

    this.$setState('current', res.data.data.product)
  }

  updateStatusUnpublishedDetail = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/ta_products/${id}/unpublished`
    )

    this.$setState('current', res.data.data.product)
  }

  updateStatusPublish = async (id, param) => {
    const res = await insuranceProductServer.post(`/ta_products/${id}/publish`)
    const response = res.data.data

    const products = this.$getState('all')

    await products.forEach(product => {
      if (product.id === response.product.id) {
        product.status = response.product.status
      }
    })

    this.$setState('all', products)
  }

  updateStatusUnpublished = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/ta_products/${id}/unpublished`
    )
    const response = res.data.data

    const products = this.$getState('all')

    await products.forEach(product => {
      if (product.id === response.product.id) {
        product.status = response.product.status
      }
    })

    this.$setState('all', products)
  }

  clearData = () => {
    this.$setState('configs', [])
    this.$setState('current', [])
  }
}

export default new PaProduct()
